import { useMutation } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export const useCompleteOnboardingDemo = () => {
  return useMutation({
    mutationKey: ['completeOnboardingDemo'],
    mutationFn: () =>
      ambientApi.put<unknown>(`/onboarding_demo`, {}).then((res) => res.data),
  });
};
